
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { FaRegUserCircle } from 'react-icons/fa';
import { MdOutlineChangeCircle } from 'react-icons/md';
import { LiaSignOutAltSolid } from "react-icons/lia";
import { IoMenu } from 'react-icons/io5';
import api from '../utils/api';

export default function TopHeader({ setNav, title, className }: any) {

    const [email, setEmail] = useState('');

    useEffect(() => {
        setEmail(window.localStorage.email);
    }, []);

    async function signOut() {

        try {

            await api.post('/auth/signout', { refresh: window.localStorage['refresh'] });

        } catch (error) {

        }

        window.localStorage.removeItem('refresh');
        window.localStorage.removeItem('token');
        window.localStorage.removeItem('email');
        window.localStorage.removeItem('name');
        window.localStorage.removeItem('id');
        window.location.replace('/signin');

    }

    return (
        <div className={`relative z-40 shrink-0 h-16 bg-white/80 backdrop-blur-xl flex flex-row items-center gap-3 px-3 sm:px-6 border-b border-slate-200/80 ${className ? className : ''}`}>
            <button
                type="button"
                aria-label="Open menu"
                className='lg:hidden shrink-0 rounded-xl p-2 text-slate-600 transition hover:bg-slate-100'
                onClick={() => {
                    if (typeof setNav === 'function') {
                        setNav(() => { });
                    }
                }}>
                <IoMenu size={24} />
            </button>
            <div className='min-w-0 flex flex-col gap-0.5'>
                <div className='truncate text-[15px] sm:text-lg font-bold leading-tight tracking-tight text-slate-900'>{title}</div>
                <div className='hidden sm:block text-[11px] leading-none text-slate-400'>Remote VPN control panel</div>
            </div>
            <div className='grow'></div>

            <div className='relative z-50 shrink-0'>
                <Menu as="div" className="relative inline-block text-left">
                    <div>
                        <MenuButton className="outline-none inline-flex w-full items-center gap-x-2 rounded-full bg-white py-1 pl-1 pr-1 md:pr-3 text-sm font-semibold text-slate-900 ring-1 ring-inset ring-slate-200 shadow-sm transition hover:ring-slate-300">
                            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-700 text-[12px] font-bold text-white">
                                {(email || '?').charAt(0).toUpperCase()}
                            </span>
                            <div className='hidden md:block max-w-[200px] truncate text-[13px] font-medium text-slate-600'>{email}</div>
                        </MenuButton>
                    </div>

                    <MenuItems
                        transition
                        className="absolute right-0 z-50 mt-2 w-60 origin-top-right overflow-hidden rounded-2xl bg-white shadow-xl shadow-slate-900/10 ring-1 ring-slate-200 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                    >
                        <div className="py-1.5 z-50">
                            <MenuItem>
                                <a
                                    href="/password-reset"
                                    className="flex items-center gap-2 px-4 py-2.5 text-sm text-slate-700 transition data-[focus]:bg-slate-50 data-[focus]:text-blue-700">
                                    <MdOutlineChangeCircle size={16} /> Change Password
                                </a>
                            </MenuItem>

                            <MenuItem>
                                <button
                                    onClick={() => signOut()}
                                    className="flex w-full items-center gap-2 px-4 py-2.5 text-left text-sm text-slate-700 transition data-[focus]:bg-red-50 data-[focus]:text-red-700">
                                    <LiaSignOutAltSolid size={16} />Sign out
                                </button>
                            </MenuItem>
                        </div>
                    </MenuItems>
                </Menu>
            </div>

        </div>
    )
}
